<template>
  <div class="wrap">
    <div class="content">
      <h3>生猪全产业链<br />追溯解决方案</h3>
      <p>
        提供溯源数据分析 制定行业溯源标准<br />让企业用户面向消费者展示更多<br />最具有公信力的溯源信息
      </p>
      <el-image class="image" :src="require('@/assets/images/qrcode.jpg')"></el-image>
      <div class="text">猪链溯源小程序</div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.wrap {
  position: relative;
  width: 100%;
  height: 7.5rem;
  background: url('../../../assets/images/prod_banner.jpg') no-repeat;
  background-size: 100% 7.5rem;
  .content {
    position: absolute;
    top: 1.375rem;
    right: 7.475rem;
    color: #fff;
    user-select: none;
    h3 {
      line-height: 0.75rem;
      font-size: 0.625rem;
      margin-bottom: 0.125rem;
    }
    p {
      line-height: 0.35rem;
      font-size: 0.225rem;
      margin-bottom: 0.1875rem;
    }
    .image {
      display: block;
      width: 1.5rem;
      height: 1.5rem;
    }
    .text {
      width: 1.5rem;
      line-height: 0.5rem;
      text-align: center;
      font-size: 0.175rem;
    }
  }
}
</style>
